import React from 'react';
import { Outlet } from 'react-router-dom';
import { AuthGuard } from 'pages/auth-guard';
import { MainProvider } from 'contexts/main.context';
import Header from './header.component';
import Footer from './footer.component';
import './basic.style.scss';

const BasicLayout = () => {
  return (
    <AuthGuard>
      <MainProvider>
        <Header />
        <div className="basicLayout__wrapper">
          <Outlet />
        </div>
        <Footer />
      </MainProvider>
    </AuthGuard>
  );
};

export default BasicLayout;
